import React, { useState, useRef, useEffect } from "react";
import styles from "./CustomDropdownMenu.module.css";
import { HEADER } from "../../utils/constants/homeConstants";
import IMAGES from "../../assets/images/images";
import { TYPE } from "../../utils/constants/userManagementConstant";

const CustomDropdownMenu = ({ header, options, onSelect, renderTrigger,selectedValue,customheight,quickSerach=false, placeholder,isInternalLogin,type=null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef();
  const headers = isInternalLogin ? HEADER.INTERNAL : HEADER.CUSTOMER;
  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchTerm("")
    }
  };

  const handleSearchChange = (event) => {
    event.preventDefault()
    setSearchTerm(event.target.value);
  };
  
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const ipxOptions = filteredOptions.filter(option => TYPE[option.type] === TYPE.ipx_service);
  
  const ivcOptions = filteredOptions.filter(option => TYPE[option.type] === TYPE.ivc_service);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.dropdownWrapper} ref={dropdownRef}>
      <div onClick={toggleDropdown}>
        {renderTrigger(isOpen)}
        </div>
      {isOpen &&(
        <div className={`${styles.dropdownMenu} ${styles[customheight]}`}>
          {quickSerach&&(
          <div className={styles.inputfieldcontainer}>
            <input
             type="text"
             placeholder={placeholder}
             value={searchTerm}
             onChange={handleSearchChange}
             className={styles.searchInput}
            />
          <div className={styles.searchwrapper}>
            <img className={styles.serchimage} src={IMAGES.searchimage} alt="Search" />
          </div>
          </div>
          )}
          <div className={styles.dropdownHeader}>
            <div className={styles.wrapper}>
            <div className={styles.header}>{header}</div>
            {header!==headers.TICKETS&&(<div className={styles.count}>Total: {options?.length}</div>)}
            </div>
          </div>
          {filteredOptions?.length === 0 && (
            <div className={styles.nodata}>
              No Data.
            </div>
          )}
          <div className={customheight&&styles.scrollable}>
          {type === "serviceType" ?(
            <>
            {ipxOptions?.length > 0 &&(
              <>
              <div className={styles.groupHeader}>
                {TYPE.ipx_service}
              </div>
              {ipxOptions.map((option, index) => (
                <div
                  key={index}
                  className={`${styles.dropdownOption} ${selectedValue?.value === option.value ? styles.selectedOption : ""}`}
                  onClick={() => {
                    onSelect(option);
                    setIsOpen(false);
                  }}
                >
                  <div className={`${styles.parent} ${selectedValue?.value === option.value ? styles.selectedvalue : ""}`}>
                  <div className={`${styles.dropdownvalue}`}>{option.label}</div>
                  </div>
                </div>
              ))}
              </>
            )}
            {ivcOptions?.length > 0 &&(
              <>
              <div className={styles.groupHeader}>
                {TYPE.ivc_service}
              </div>
              {ivcOptions.map((option, index) => (
                <div
                  key={index}
                  className={`${styles.dropdownOption} ${selectedValue?.value === option.value ? styles.selectedOption : ""}`}
                  onClick={() => {
                    onSelect(option);
                    setIsOpen(false);
                  }}
                >
                  <div className={`${styles.parent} ${selectedValue?.value === option.value ? styles.selectedvalue : ""}`}>
                  <div className={`${styles.dropdownvalue}`}>{option.label}</div>
                  </div>
                </div>
              ))}
              </>
            )}
            </>
          ):
          filteredOptions.map((option, index) => (
            <div
              key={index}
              className={`${styles.dropdownOption} ${selectedValue?.value === option.value ? styles.selectedOption : ""}`}
              onClick={() => {
                onSelect(option);
                setIsOpen(false);
              }}
            >
              <div className={`${styles.parent} ${selectedValue?.value === option.value ? styles.selectedvalue : ""}`}>
              <div className={`${styles.dropdownvalue}`}>{option.label}</div>
              {/* {type && <div className={styles.type}>{TYPE[option.type]}</div>} */}
              </div>
            </div>
          ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdownMenu;
